import React, { useState, useEffect } from "react";
import ViewTradingServices from "../../services/ViewTradingServices";

function ScannerViewTrading() {
    const [data, setData] = useState([]);
    const [date, setDate] = useState(""); // Selected date

    const handleDateChange = (event) => {
        setDate(event.target.value);
    };

    const currentDate = new Date().toISOString().split("T")[0];

    useEffect(() => {
        const selectedDate = date || currentDate;

        ViewTradingServices.getTodayViewTrading(selectedDate)
            .then((response) => {
                console.log("API Response:", response?.data);
                setData(response?.data || []);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [date]);

    return (
        <section className="sr-stocks-section py-70">
            <div className="container-fluid">
                {/* Date Picker */}
                <div className="row justify-content-end">
                    <div className="col-md-4">
                        <input
                            className="form-control"
                            type="date"
                            value={date || currentDate}
                            onChange={handleDateChange}
                            style={{ width: "100%" }}
                        />
                    </div>
                </div>

                {/* Trade Summary Boxes */}
                {data.length > 0 ? (
                    <>
                        {/* <h4 className="mt-4 mb-3">Trade Summary</h4> */}
                        <div className="row">
                            {data.map((item) => (
                                <div key={item._id} className="col-md-4 mb-4">
                                    <div className="card shadow-sm border text-center"> {/* Center align all content */}
                                        <div className="card-body">
                                            <h5 className="card-title mb-3 fs-4 fw-bold">{item?.symbol?.toUpperCase()}</h5> {/* fs-4 for larger font */}
                                            {item.timestamp && (
                                                <h4 className="card-text text-muted mt-2 fs-5">
                                                    <strong>Time:</strong><span>
                                                        {new Date(item.timestamp).toLocaleTimeString('en-US', {
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true,
                                                            timeZone: 'UTC' // Ensures time is shown in UTC
                                                        })}
                                                    </span>


                                                </h4>
                                            )}
                                            <h3 className={`card-text fw-bold  ${item.direction === 'BUY' ? 'text-success' : 'text-danger'}`}>
                                                <strong>Direction:</strong> {item?.direction === 'BUY' ? 'BULLISH' : item.direction === 'SELL' ? 'BEARISH' : item.direction}
                                            </h3>
                                            <p className="card-text mb-2 fs-5">
                                                <strong>Price:</strong> {item?.price}
                                            </p>
                                            <p className="card-text mb-2 fs-5">
                                                <strong>Quantity:</strong> {item?.qty}
                                            </p>
                                            <p className="card-text mb-2 fs-5">
                                                <strong>Target Price:</strong> {item?.TP}
                                            </p>
                                            <p className="card-text mb-2 fs-5">
                                                <strong>Stop Price:</strong> {item?.SP}
                                            </p>


                                            
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <div className="row mt-4">
                        <div className="col-12 text-center">
                            <p>No trade data available</p>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}

export default ScannerViewTrading;
